<template>
  <div class="Page Home">
    <h2 class="subtitle">Exporter des contenus</h2>
    <section>
      <div v-if="isEmpty">
        Il n'y a rien dans le <i class="fa fa-folder-open"></i> classeur. <br/>
        Commencez par y ajouter des contenus.
      </div>
      <div v-else>
        <div class="field">
          <button class="button" @click="selectAll">Tout sélectionner
          </button
          >&nbsp;<button
          v-show="selected.length > 0"
          class="button"
          @click="deselectAll"
        >
          Tout désélectionner
        </button>
        </div>
        <div style="display: flex;">
          <div class="Export__candidates">
            <export-item
              v-for="(i, index) in items"
              :key="i.content.uuid"
              :item="i"
              :detailed="true"
              :selected.sync="selection[index]"
            ></export-item>
          </div>
          <div style="flex: 0 0 250px; margin-left: 1em;">
            <div v-show="selected.length > 0">
              <h3 class="subtitle" style="margin-bottom: 0.5em">
                Exports possibles
              </h3>
              <div class="buttons">
                <router-link
                  class="button"
                  style="text-decoration: none; margin-bottom: .5em;"
                  :to="
                  `/export/summary/${selected.map(a => a.content.id).join(',')}`
                "
                >
                  <i class="fa fa-file"></i>&nbsp; Fiches récapitulatives
                </router-link>
                <router-link
                  class="button"
                  style="text-decoration: none; margin-bottom: .5em;"
                  :to="
                  `/export/fichettes/${selected.map(a => a.content.id).join(',')}`
                "
                >
                  <i class="fa fa-file"></i>&nbsp; Fichettes A5
                </router-link>
                <router-link
                  class="button"
                  style="text-decoration: none;"
                  :to="
                  `/export/index_projet/${selected
                    .map(a => a.content.id)
                    .join(',')}`
                "
                ><i class="fa fa-table"></i>&nbsp;Index Visuel
                </router-link
                >
                <router-link class="button"
                             style="text-decoration: none;"
                             :to="`/export/kit_presse/${selected.map(a => a.content.id).join(',')}`"><i
                  class="fa fa-file-archive"></i>&nbsp;Kit presse
                </router-link>
                <router-link
                  style="text-decoration: none;"
                  class="button"
                  :to="
                  `/export/index_projet_txt/${selected
                    .map(a => a.content.id)
                    .join(',')}`
                "
                ><i class="fa fa-table"></i>&nbsp;Index Textuel
                </router-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import ExportItem from "../../components/Basket/ExportItem";
  import {defaultApiUrl} from "../../api";

  export default {
    name: "ExportHome",
    components: {ExportItem},
    defaultApiUrl,
    data() {
      return {
        selection: []
      };
    },
    computed: {
      items() {
        return this.$store.state.basket;
      },
      isEmpty() {
        return this.items.length === 0;
      },
      selected() {
        return this.items.filter((_, i) => this.selection[i]);
      }
    },
    methods: {
      createSelectionMap() {
        this.selection = this.items.map(() => false);
      },
      selectAll() {
        this.selection = this.items.map(() => true);
      },
      deselectAll() {
        this.selection = this.items.map(() => false);
      }
    },
    watch: {
      items() {
        this.createSelectionMap();
      }
    },
    mounted() {
      this.createSelectionMap();
    }
  };
</script>

<style lang="scss">
  .Export {
    &__candidates {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      position: relative;

      & > div {
        @lost gutter 8px;
        lost-column: 1/4;
        margin-bottom: 16px;
      }
    }
  }
</style>
